module.exports = __webpack_public_path__ + "static/img/labourservices-5.40b7030.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/rescuelist/img/list/labourservices-5.png
// module id = 12kH
// module chunks = 1